import { render, staticRenderFns } from "./sign-up-form-section.vue?vue&type=template&id=0e6989a0&"
import script from "./sign-up-form-section.vue?vue&type=script&lang=js&"
export * from "./sign-up-form-section.vue?vue&type=script&lang=js&"
import style0 from "./sign-up-form-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports